import React from 'react'

const EtAdminSessions = () => {
  return (
    <div>EtAdminSessions</div>
  )
}

export default EtAdminSessions